import { registerIconAlias } from '@uifabric/styling/lib/index';

registerIconAlias('trash', 'delete');
